import { Deck, DeckCard } from "@apiserver-rest/ponder-data-client-base";
import { DeckGroup } from "@ponder-features/user/decks/deck/group/deck-group";
import { environment } from "../../../../../environments/environment";

export class MagicDeckGroupEnchantments extends DeckGroup {
    public constructor() {
        super("Enchantments", `${environment.ponderImageBaseUrl}/magic/set/ori.svg`);
    }
    
    public override isValid(deck: Deck, card: DeckCard): boolean {
        if (card.card.item.data?.magic) {
            var frontFace = card.card.item.data.magic.faces![0];

            if (frontFace.typeLine?.includes("Enchantment")) {
                return true;
            }
        }

        return false;
    }
}